import React from "react";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import useAppContext, { ACCOUNT_TYPES } from "state/AppContext";
import { Navbar, MobileNav, Typography, Button, IconButton } from "@material-tailwind/react";

export default function OrderMainNav() {
  const [openNav, setOpenNav] = useState(false);
  const appContext = useAppContext();
  const { recruiterUsername, clientUsername } = useParams();
  const { account, selectedRecruiter, selectedCluster, selectedOrderName } = appContext;

  const baseURL = `/recruiters/${recruiterUsername}/clients/${clientUsername}/orders/${selectedOrderName}`;

  const dashboardRoute = `${baseURL}`;
  const orderStatusRoute = `${baseURL}/order-status`;
  const orderShortlistRoute = `${baseURL}/candidate-shortlist`;
  const orderJobPostingRoute = `${baseURL}/job-posting`;
  const orderAnalyticsRoute = `${baseURL}/analytics`;
  const orderNotificationsRoute = `${baseURL}/notifications`;
  const orderSettingsRoute = `${baseURL}/settings`;

  useEffect(() => {
    window.addEventListener("resize", () => window.innerWidth >= 960 && setOpenNav(false));
  }, []);

  const navList = (
    <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      <Typography as="li" variant="small" color="blue-gray" className="p-1 font-normal">
        <Link to={dashboardRoute}>Dashboard</Link>
      </Typography>
      <Typography as="li" variant="small" color="blue-gray" className="p-1 font-normal">
        <Link to={orderJobPostingRoute}>Job Posting</Link>
      </Typography>
      <Typography as="li" variant="small" color="blue-gray" className="p-1 font-normal">
        <Link to={orderShortlistRoute}>Shortlist</Link>
      </Typography>
      {account.accountType.type !== ACCOUNT_TYPES.EMPLOYER ? (
        <Typography as="li" variant="small" color="blue-gray" className="p-1 font-normal">
          <Link to={orderAnalyticsRoute}>Analytics</Link>
        </Typography>
      ) : null}
      <Typography as="li" variant="small" color="blue-gray" className="p-1 font-normal">
        <Link to={orderNotificationsRoute}>Notifications</Link>
      </Typography>
      <Typography as="li" variant="small" color="blue-gray" className="p-1 font-normal">
        <Link to={orderSettingsRoute}>Settings</Link>
      </Typography>
    </ul>
  );

  return (
    <div className="container mx-auto rounded-lg mt-2 py-2 bg-white px-4 lg:px-8 lg:py-4 shadow-md blur-2 text-opacity-15 spread-0">
      <div className="container mx-auto flex items-center justify-between text-blue-gray-900">
        <Link to={dashboardRoute}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/2560px-Amazon_logo.svg.png"
            alt="Amazon logo"
            className="h-[25px]"
          />
        </Link>
        <div className="hidden lg:block">{navList}</div>
        <Link to={orderStatusRoute}>
          <Button variant="gradient" size="sm" className="hidden lg:inline-block rounded-full">
            <span>Order Status</span>
          </Button>
        </Link>
        <IconButton
          variant="text"
          className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
          ripple={false}
          onClick={() => setOpenNav(!openNav)}
        >
          {openNav ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              className="h-6 w-6"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </IconButton>
      </div>
      <MobileNav open={openNav}>
        <div className="container mx-auto">
          {navList}
          <Button variant="gradient" size="sm" fullWidth className="mb-2">
            <span>Buy Now</span>
          </Button>
        </div>
      </MobileNav>
    </div>
  );
}
